import React from "react";
import { inject, observer } from "mobx-react";

/*

requirement: react component must have rootStore with user object which has roles array

input: allowedRoles: array of allowed roles as string
return function ( WrappedComponent, inline = false, elementProps = {} )

function input: WrappedComponent: react component to render in allowed case
function input: inline: boolean
function input: elementProps: object to hold any component props from the WrappedComponent
function return: React component, WrappedComponent if allowed, else  "Not Authorized"

 */
const Authorization = allowedRoles => (
  WrappedComponent,
  inline = false,
  elementProps = {}
) => {
  const element =
    @inject("rootStore")
    class WithAuthorization extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          user: {
            name: this.props.rootStore.user.name,
            roles: this.props.rootStore.user.roles
          }
        };
      }

      render() {
        const { roles } = this.state.user;

      //  console.log(allowedRoles);
        if (roles.some(role => allowedRoles.includes(role))) {
          return <WrappedComponent {...this.props} {...elementProps} />;
        } else {
          return inline ? null : (
            <div className="not-found-error">Not authorized</div>
          );
        }
      }
    };
  if (inline) {
    return React.createElement(element);
  } else {
    return element;
  }
};

const AuthorizeComponent = can => (
  WrappedComponent,
  inline = false,
  elementProps = {}
) => {
  const element = class WithAuthorization extends React.Component {
    render() {
      if (can) {
        return <WrappedComponent {...this.props} {...elementProps} />;
      } else {
        return inline ? null : (
          <div className="not-found-error">Not authorized</div>
        );
      }
    }
  };
  if (inline) {
    return React.createElement(element);
  } else {
    return element;
  }
};

/*
requirement: react component must have rootStore with user object which has roles array

input: allowedRoles: array of allowed roles as string
return function ( rootStore )

function input: rootStore
function return: boolean, true if allowed, false otherwise
*/

const AuthorizationAPI = allowedRoles => rootStore => {
  if (
    rootStore &&
    rootStore.user.roles.some(role => allowedRoles.includes(role))
  ) {
    return true;
  } else {
    return false;
  }
};

export { Authorization, AuthorizeComponent, AuthorizationAPI };
